module.exports = __webpack_public_path__ + "assets/img/8_1690_big.95fcb28d.jpg";